import React, { useState } from "react";
import TextField from "../../components/formcomponents/TextField";
import { FaFileUpload } from "react-icons/fa";
import { useDispatch } from "react-redux";
import Dropdown from "../../components/dropdown/DropDown";
import { uploadPanelPhoto } from "../../redux/actions/action";
import { uploadJudgePhoto } from "../../redux/actions/action";

const Panels = ({ type, onClose, onSubmit }) => {
  const initialData = {
    name: "",
    role: "",
    affiliation: "",
    expertise: "",
    experienceInMonths: "",
    availability: "",
    photo: null,
    preview: null, // 👈 add this
  };

  const [items, setItems] = useState([initialData]);
  const dispatch = useDispatch();

  const handleItemChange = (index, field, value) => {
    setItems((prevItems) =>
      prevItems.map((item, i) => {
        if (i !== index) return item;
        if (field === "photo") {
          return {
            ...item,
            photo: value,
            preview: value ? URL.createObjectURL(value) : null,
          };
        }
        return { ...item, [field]: value };
      })
    );
  };


  const handleAddItem = () => {
    setItems([...items, { ...initialData }]);
  };

  const handleRemoveItem = () => {
    if (items.length > 1) {
      setItems(items.slice(0, -1));
    }
  };

  const handleSubmit = async () => {
    const isValid = items.every(item =>
      item.name.trim() !== "" &&
      item.expertise.trim() !== "" &&
      item.experienceInMonths !== "" &&
      item.availability.trim() !== "" &&
      item.affiliation.trim() !== "" &&
      (["mentor", "judge"].includes(type) ? item.role.trim() !== "" : true)
    );

    if (!isValid) {
      alert("Please fill in all required fields.");
      return;
    }

    try {
      const uploadAction = type === "judge" ? uploadJudgePhoto : uploadPanelPhoto;
      // Upload all panel photos
      const updatedItems = await Promise.all(
        items.map(async (item) => {
          if (item.photo) {
            const formData = new FormData();
            formData.append("image", item.photo);
            formData.append("panelName", item.name); // optional
  
           // const response = await dispatch(uploadPanelPhoto(formData));
           const response = await dispatch(uploadAction(formData));
            
            //console.log("Uploaded photo for:", item.name);
            console.log(`Uploaded photo for ${type}:`, item.name);
  
            return {
              ...item,
              //uploadedUrl: response || null,
              photo: response || null,
            };
          }
          return item;
        })
      );
  
      // Now submit the full panel data
      console.log("updated items are "+JSON.stringify(updatedItems),null,2);
      onSubmit?.(updatedItems);
      onClose?.();
  
    } catch (err) {
      console.error("Error submitting form or uploading photos:", err);
      alert("Something went wrong. Please try again.");
    }
  };
  

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      {/* <div className="absolute top-[0px] left-[284px] bg-color p-6 rounded-lg shadow-lg w-[750px] min-h-[560px] max-h-[80vh] overflow-y-auto"> */}
        <div className="bg-color p-6 rounded-lg shadow-lg w-[750px] min-h-[560px] max-h-[80vh] overflow-y-auto">

        <div>
          <div className="grid grid-cols-2 gap-5">
            {items.map((item, index) => (
              <div key={index} className="relative mb-0">
                <h4 className="font-poppins text-base-2 font-semibold underline mb-2">
                  Details of {type.charAt(0).toUpperCase() + type.slice(1)} {index + 1}:
                </h4>

                {/* Upload Photo */}

                <div className="flex flex-col items-start mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Upload {type} Photo
                  </label>
                  <div className="relative w-[120px] h-[120px] rounded border border-gray-300 overflow-hidden flex items-center justify-center bg-white shadow">
                    {item.preview ? (
                      <img
                        src={item.preview}
                        alt="Preview"
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <FaFileUpload className="text-gray-400 text-3xl" />
                    )}
                    <input
                      type="file"
                      accept="image/*"
                      className="absolute inset-0 opacity-0 cursor-pointer"
                      onChange={(e) =>
                        handleItemChange(index, "photo", e.target.files[0])
                      }
                    />
                  </div>
                </div>


                <div className="mt-2 w-[350px]">
                  <TextField
                    label={`Name of ${type}*`}
                    type="text"
                    value={item.name}
                    onChange={(e) => handleItemChange(index, "name", e.target.value)}
                    placeholder={`Enter ${type}'s Name`}
                    required
                  />
                </div>


                {["mentor", "judge"].includes(type) && (
                  <TextField
                    label="Role*"
                    value={item.role}
                    onChange={(e) => handleItemChange(index, "role", e.target.value)}
                    placeholder={`Enter ${type}'s Role`}
                    required
                  />
                )}

                <div className="mt-2 w-[350px]">
                  <TextField
                    label="Affiliation*"
                    type="text"
                    value={item.affiliation}
                    onChange={(e) => handleItemChange(index, "affiliation", e.target.value)}
                    placeholder="Enter Affiliation"
                    required
                  />
                </div>

                <div className="mt-2 w-[350px]">
                  <TextField
                    label="Expertise*"
                    type="text"
                    value={item.expertise}
                    onChange={(e) => handleItemChange(index, "expertise", e.target.value)}
                    placeholder="Enter Expertise"
                    required
                  />
                </div>

                <div className="mt-2 w-[350px]">
                  <label className="block mb-1">Experience in months*</label>
                  <select
                    value={item.experienceInMonths}
                    onChange={(e) => handleItemChange(index, "experienceInMonths", e.target.value)}
                    className="w-full p-2 rounded-md border border-gray-300 text-black"
                    required
                  >
                    <option value="">Select experience (in months)</option>
                    {Array.from({ length: 121 }, (_, i) => (
                      <option key={i} value={i}>
                        {i} {i === 1 ? 'month' : 'months'}
                      </option>
                    ))}
                  </select>
                </div>


                <div className="mt-2 w-[350px]">
                  <label className="block mb-1">Availability*</label>
                  <select
                    value={item.availability}
                    onChange={(e) => handleItemChange(index, "availability", e.target.value)}
                    className="w-full p-2 rounded-md text-black border border-gray-300"
                  >
                    <option value="">Select Availability</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>


                {index === items.length - 1 && (
                  <div className="flex space-x-4 mt-4">
                    <button
                      type="button"
                      onClick={handleAddItem}
                      className="bg-white text-black py-2 px-4 font-semibold rounded-md hover:bg-blue-600 transition duration-200"
                    >
                      Add {type}
                    </button>
                    {items.length > 1 && (
                      <button
                        type="button"
                        onClick={handleRemoveItem}
                        className="bg-white text-black py-2 px-4 font-semibold rounded-md hover:bg-red-600 transition duration-200"
                      >
                        Remove
                      </button>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="flex justify-center space-x-4 mt-8 mb-10">
            <button
              type="button"
              onClick={onClose}
              className="bg-black text-white py-2 px-6 font-semibold rounded-md hover:bg-gray-600 transition duration-200"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleSubmit}
              className="bg-black text-white py-2 px-6 font-semibold rounded-md hover:bg-blue-600 transition duration-200"

            >
              Submit
            </button>


          </div>
        </div>
      </div>
    </div>
  );
};

export default Panels;
